import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Select,
  MenuItem,
  Grid,
  IconButton
}
  from '@material-ui/core';

import DateFnsUtils from '@date-io/date-fns';

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
// import MuiAlert from '@material-ui/lab/Alert';
import config from '../../../../config/config.json'
import _ from 'lodash';
import AutorenewIcon from '@material-ui/icons/Autorenew';
const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3)
  },
  spacer: {
    flexGrow: 1
  },
  selectButton: {
    marginLeft: theme.spacing(3)
  },
  datePiker: {
    marginRight: theme.spacing(3)

  },
  toggleButton: {
    marginRight: theme.spacing(3)
    // marginTop: theme.spacing(3)

  },
  select: {
    marginRight: theme.spacing(3),
    marginTop: theme.spacing(4)

  }
}));

// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }


const Toolbar = props => {
  const { className, date, meal, onDateChange, onMealChange, onMakeReport, onCouponStateFilter, onCustomerTypeFilter, ...rest } = props;

  const classes = useStyles();

  // const [selectedStartDate, setSelectedStartDate] = React.useState(new Date());
  // const [selectedEndDate, setSelectedEndDate] = React.useState(new Date());
  const [selectedDate, setSelectedDate] = React.useState(date);
  const [selectedMeal, setSelectedMeal] = useState(_.filter(config.mealsTypes, ['name', 'Завтрак'])[0].id);


  const handleDateChange = newDate => {
    onDateChange(newDate);
  };

  const handleMealChange = event => {
    onMealChange(event.target.value);
  };


  useEffect(() => {
    setSelectedDate(props.date)
    // setSelectedEndDate(props.endDate)
  }, [props.date]);


  useEffect(() => {
    setSelectedMeal(props.meal)
    // setSelectedEndDate(props.endDate)
  }, [props.meal]);

  useEffect(() => {
    setCouponStateFilter(props.couponStateFilter)
  }, [props.couponStateFilter]);


  useEffect(() => {
    setCustomerTypeFilter(props.customerTypeFilter)
  }, [props.customerTypeFilter]);


  // Состояние кнпок статуса и типа участников
  const [couponStateFilter, setCouponStateFilter] = React.useState(() => 3);
  const [customerTypeFilter, setCustomerTypeFilter] = React.useState(() => 2);

  const handleCouponStateFilter = (event, newValue) => {
    // setCouponStateFilter(newValue);
    onCouponStateFilter(newValue)
  };
  const handleCustomerTypeFilter = (event, newValue) => {
    onCustomerTypeFilter(newValue);
  };


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>

      {/* <div
        {...rest}
        className={clsx(classes.root, className)}
      > */}

        {/* <div className={classes.row}> */}
        {/* <SearchInput
          className={classes.searchInput}
          placeholder="Search user"
        /> */}
<Grid
  container
  direction="column"
  justify="flex-start"
  alignItems="stretch"
  spacing={1}
>
<Grid
            item
            xs={12}
          >
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={1}

        >
          <Grid
            item
            sm={'auto'}
            xs={6}
          >
            <KeyboardDatePicker
              // className={classes.datePiker}
              margin="normal"
              id="date-picker-dialog"
              label="Выберите начальную дату"
              format="dd.MM.yyyy"
              value={selectedDate}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </Grid>

          <Grid
            item
            sm={'auto'}
            xs={4}
          >
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={meal}
            className={classes.select}
            onChange={handleMealChange}
          >
            <MenuItem value={_.filter(config.mealsTypes, ['name', 'Завтрак'])[0].id}>Завтрак</MenuItem>
            <MenuItem value={_.filter(config.mealsTypes, ['name', 'Обед'])[0].id}>Обед</MenuItem>
            <MenuItem value={_.filter(config.mealsTypes, ['name', 'Ужин'])[0].id}>Ужин</MenuItem>

          </Select>
        </Grid>
        <Grid
          item
          sm={'auto'}
          xs={2}
        >
          {/* <Button variant="contained" color="primary" className={classes.selectButton} onClick={onMakeReport}>
            Выбрать
      </Button> */}
                <IconButton aria-label="add" onClick={onMakeReport} color="primary" style={{marginTop:12}}>
            <AutorenewIcon fontSize="large" />
          </IconButton>
        </Grid>
      
      </Grid>
      </Grid>
      <Grid
            item
            sm={12}
          >

<Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-start"
          spacing={1}
        >   
                  <Grid
            item
            sm={'auto'}
            xs={12}
          >
      {/* </div> */}
      {/* <div className={classes.row}> */}
        {/* <Typography variant="h3" component="h2" gutterBottom>
          В сумме: <b>{total.toLocaleString('ru')} ฿</b>
      </Typography> */}
        <ToggleButtonGroup aria-label="text formatting" size="small" exclusive value={couponStateFilter} onChange={handleCouponStateFilter} className={classes.toggleButton}>
          <ToggleButton value={1} aria-label="bold">
            Не выдан
            </ToggleButton>
          <ToggleButton value={2} aria-label="italic">
            Выдан
            </ToggleButton>
          <ToggleButton value={3} aria-label="underlined">
            Все
            </ToggleButton>
        </ToggleButtonGroup>
        </Grid>
        <Grid
            item
            sm={'auto'}
            xs={12}
          >
        <ToggleButtonGroup aria-label="text formatting" size="small" exclusive value={customerTypeFilter} onChange={handleCustomerTypeFilter}>
          <ToggleButton value={0} aria-label="bold">
            Участники
            </ToggleButton>
          <ToggleButton value={1} aria-label="italic">
            Сотрудники
            </ToggleButton>
          <ToggleButton value={2} aria-label="underlined">
            Все
            </ToggleButton>
        </ToggleButtonGroup>
        </Grid>

        </Grid>

      {/* </div> */}
      </Grid>
      </Grid>
    {/* </div> */}
    </MuiPickersUtilsProvider >

  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
